
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import PieChart from "@/components/PieChart/index.vue";
import { moneyFormat } from "@/utils/util";
import { getMembershipStatistics } from "@/api/shouyin";

// 会员分析
@Component({
  components: {
    CardContainer,
    PieChart,
  },
})
export class MemberAnalysis extends Vue {
  @Prop({ default: () => ({}) }) params!: any;

  isInit = false;
  paramsPieChart: any = {
    type: "percent",
    isSimple: true,
    data: [
      { name: "会员", value: "0", prop: "membershipOrderMoney" },
      { name: "非会员", value: "0", prop: "ordinaryOrderMoney" },
    ],
  };
  moneyFormat = moneyFormat;
  grid = [
    {
      label: "会员消费",
      value: 2600,
      prop: "membershipOrderMoney",
      isMoney: true,
    },
    {
      label: "非会员消费",
      value: 2800,
      prop: "ordinaryOrderMoney",
      isMoney: true,
    },
    {
      label: "新增会员数",
      value: 68,
      prop: "newMembershipNumber",
      isMoney: false,
    },
    {
      label: "会员储值余额",
      value: "136580",
      prop: "storedValueBalance",
      isMoney: true,
    },
  ];
  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  getData() {
    this.isInit = false;
    const params = { ...this.params, queryType: this.params.orderType };
    getMembershipStatistics(params).then((res) => {
      this.grid.forEach((item) => {
        item.value = res.data[item.prop];
      });
      const total =
        res.data.membershipOrderMoney + res.data.ordinaryOrderMoney || 1;
      this.paramsPieChart.data.forEach((item) => {
        const v = res.data[item.prop] || 0;
        item.value = Math.round(Number(v / total) * 10000) / 100;
      });
      this.isInit = true;
    });
  }
}
export default MemberAnalysis;
